import firebase from 'firebase';
import _ from 'lodash';
import Events from '../_utils/events.js';

class PlayersService extends Events {

	/*constructor() {
		super();
	}*/

	toArrayWithIds(__players) {
		let
		players = [];

		// Is a Firebase Object
		if (__players.forEach) {
			__players.forEach(__player => {
				players.push(_.extend({playerId: __player.key}, __player.val()));
			});
		} 
		// Is a common object
		else {
			_.each(__players, (player, playerKey) => {
				players.push(_.extend({playerId: playerKey}, player));
			});
		}

		return players;
	}

	/*
	onValue(callback, filter) {
		switch (filter) {
			case all: {
				startAllPlayersQuery()
			}
		}
		firebase.database().ref('players/').on('value');
	}

	startAll*/

	/*getAllPlayers(callback, callType) {
		if (!this.players) {
			
		}
		return firebase.database().ref('players/').on('value', __players => {
			this.__players = __players;
			this.trigger('players:value:change', this.__players);
		});
	}*/
}

let playersService = new PlayersService();

export default playersService;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/_services/players.service.js